import * as React from "react";
import type { SVGProps } from "react";
const SvgImage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 11c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3m0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 22h12c2.21 0 4-1.79 4-4V6c0-2.21-1.79-4-4-4H6C3.79 2 2 3.79 2 6v12c0 2.21 1.79 4 4 4M4 6c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v8.6l-1.31-1.31c-1.31-1.27-3.07-1.27-4.4.01l-.29.29-2.3-2.3c-1.31-1.27-3.08-1.27-4.4.01L4 14.6zm0 11.42 4.69-4.7c.55-.52 1.07-.52 1.6-.01l2.997 2.997.003.003.003.003 1.997 1.997c.2.19.45.29.71.29s.51-.09.71-.29a.996.996 0 0 0 0-1.41l-1.3-1.3.28-.28c.55-.52 1.07-.52 1.6-.01L20 17.42V18c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgImage;
